<script setup>
const props = defineProps(['content', 'blue']);
</script>

<template>
  <span class="tag" :class="{ 'tag--blue': props.blue ? props.blue : false }"> {{ props.content }}</span>
</template>

<style lang="scss" scoped>
.tag {
  background: $sienna;
  color: $white;
  display: inline-block;
  font-size: 12px;
  line-height: 12px;
  padding: 7px 7px 6px;
  text-transform: uppercase;

  &--blue {
    background: $blue;
  }
}
</style>
